<template>
    <div>
        <datatable-filter
            v-show="datatable.filterStatus"
            @filter="getRows"
            @filterClear="filterClear"
            :export-excel="checkPermission('infirmaryuser_excelexport')"
            @exportExcel="exportExcel"
        >
            <b-row>
                <b-col sm="6" md="3">
                    <b-form-group :label="$t('national_id')">
                        <b-form-input type="text" v-model="datatable.queryParams.filter.national_id"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="3">
                    <b-form-group :label="$t('name')">
                        <b-form-input type="text" v-model="datatable.queryParams.filter.name"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="3">
                    <b-form-group :label="$t('surname')">
                        <b-form-input type="text" v-model="datatable.queryParams.filter.surname"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="3">
                    <b-form-group :label="$t('gender')">
                        <GenderSelectbox
                            v-model="datatable.queryParams.filter.gender">
                        </GenderSelectbox>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="3">
                    <b-form-group :label="$t('updated_at')">
                        <ValidationProvider name="date" rules="" v-slot="{valid, errors}">
                            <v-date-picker v-model="datatable.queryParams.filter.date"
                                           is-range
                                           :model-config="{type: 'string', mask: 'YYYY-MM-DD'}"
                            >
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="border rounded-sm p-1 p-md-3 d-flex align-items-center" :class="errors[0] ? 'box-border-color':''">
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 mr-1">
                                                <input :value="inputValue.start"
                                                       v-on="inputEvents.start"
                                                       :placeholder="$t('start_date')"
                                                       class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                        <div class="flex-grow-1">
                                            <b-form-group class="m-0 ml-1">
                                                <input :value="inputValue.end"
                                                       v-on="inputEvents.end"
                                                       :placeholder="$t('end_date')"
                                                       class="form-control"
                                                />
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                </template>
                            </v-date-picker>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="3">
                    <b-form-group :label="$t('unit')">
                        <parameter-selectbox code="infirmary_guest_units"
                                             v-model="datatable.queryParams.filter.unit"/>
                    </b-form-group>
                </b-col>
            </b-row>

        </datatable-filter>
        <datatable :isLoading.sync="datatable.isLoading"
                   :columns="datatable.columns"
                   :rows="datatable.rows"
                   :total="datatable.total"
                   :queryParams="datatable.queryParams"
                   @on-page-change="onPageChange"
                   @on-sort-change="onSortChange"
                   @on-per-page-change="onPerPageChange"
                   v-show="datatable.showTable">
        </datatable>
        <CommonModal ref="storeGuestModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
            <template v-slot:CommonModalTitle>
                {{ $t('new').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <StoreForm v-if="formProcess==='storeGuestModal'" @closeInfirmaryModal="closeInfirmaryModal"/>
            </template>
        </CommonModal>
        <CommonModal ref="updateGuestModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
            <template v-slot:CommonModalTitle>
                {{ $t('new').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <UpdateForm v-if="formProcess==='updateGuestModal'" @closeUpdateInfirmaryModal="closeUpdateInfirmaryModal" :formId="formId"/>
            </template>
        </CommonModal>
    </div>
</template>
<script>
import qs from "qs";
import InfirmaryServices from "@/services/InfirmaryServices";
import {EventBus} from '@/main'
import StoreForm from "./StoreForm.vue";
import UpdateForm from "./UpdateForm.vue";

export default {
    name: "Guest",
    components: {UpdateForm, StoreForm},
    data() {
        return {
            formId:null,
            formProcess: null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('edit_patient_information'),
                                class: 'ri-edit-box-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "infirmaryuser_updateuserdetail",
                                callback: (row) => {
                                    this.openUpdateFormShow(row.id)
                                }
                            },
                            {
                                text: this.$t('create_new_examination'),
                                class: 'ri-add-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "infirmaryrecord_createinfirmaryrecord",
                                disabled:(row)=>{
                                    return  row.id===null
                                },
                                callback: (row) => {
                                    this.$emit('createNewExamination',row.id)
                                },
                            },
                            {
                                text: this.$t('patient_history'),
                                class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "infirmaryrecord_indexinfirmaryrecord",
                                disabled:(row)=>{
                                    return  row.id===null
                                },
                                callback: (row) => {
                                    this.$emit('openPatientHistoryModal',row.id)
                                },
                            },
                            {
                                text: this.$t('delete_infirmary_user'),
                                class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                permission: "infirmaryuser_delete",
                                callback: (row) => {
                                    this.formDelete(row.id)
                                },
                                show: (row) => {
                                    return row && row.id != null;
                                }
                            }
                        ]
                    },
                    {
                        label: this.toUpperCase('id'),
                        field: 'id',
                        hidden: true,
                    },
                    {
                        label: this.toUpperCase('national_id'),
                        field: 'national_id',
                        hidden: false,

                    },
                    {
                        label: this.toUpperCase('name'),
                        field: 'name',
                        hidden: false,

                    },
                    {
                        label: this.toUpperCase('surname'),
                        field: 'surname',
                        hidden: false,

                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 20
                }
            },
        }
    },
    mounted() {
        EventBus.$on('openStoreGuestModal', () => {
            this.storeGuestModal()
        })
    },
    methods: {
        formClear() {
            this.formProcess = null
        },
        filterSet() {
            this.datatable.queryParams.filter = {
                national_id: null,
                name: null,
                surname: null,
                gender: null,
            }
        },
        filterClear() {
            this.filterSet();
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        changeColumn(key) {
            this.datatable.columns[key].hidden = this.datatable.columns[key].hidden == true ? false : true;
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field
            this.getRows();
        },
        getPayloadFilters() {
            let filters = {...this.datatable.queryParams.filter}

            let payloadFilters = {...filters}

            if (filters.date?.start) {
                payloadFilters.infirmary_updated_at_greater_than = filters.date.start;
            }

            if (filters.date?.end) {
                payloadFilters.infirmary_updated_at_smaller_than = filters.date.end;
            }

            delete payloadFilters.date
            return {
                params:{
                    filter:{
                        ...payloadFilters,
                    },
                    limit: this.datatable.queryParams.limit,
                    page: this.datatable.queryParams.page,
                    sort: this.datatable.queryParams.sort
                }
            }
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                ...this.getPayloadFilters(),
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };
            return InfirmaryServices.guestGetAll(config).then(response => {
                this.datatable.rows = response.data.data
                this.datatable.total = response.data.pagination.total
            }).finally(() => {
                this.datatable.isLoading = false;
            });
        },
        storeGuestModal(){
            this.formProcess='storeGuestModal'
            this.$refs.storeGuestModal.$refs.commonModal.show()
        },
        closeInfirmaryModal(){
            this.formProcess=null
            this.$refs.storeGuestModal.$refs.commonModal.hide()
            this.getRows()
        },
        openUpdateFormShow(id){
            this.formId=id
            this.formProcess='updateGuestModal'
            this.$refs.updateGuestModal.$refs.commonModal.show()
        },
        closeUpdateInfirmaryModal(){
            this.formId=null
            this.formProcess=null
            this.$refs.updateGuestModal.$refs.commonModal.hide()
            this.getRows()
        },
        exportExcel(){
            let config = this.getPayloadFilters()
            config.params.filter.type = 'guest'
            this.$emit('excelExport', config)
        },
        formDelete(id) {
            this.$swal
                .fire({
                    text: this.$t('are_you_sure_to_delete'),
                    showCancelButton: true,
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        InfirmaryServices.deleteInfirmaryUser(id)
                            .then(response => {
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.getRows();
                                this.formClear();
                            })
                            .catch(error => {
                                this.$toast.error(this.$t('api.' + error.data.message));
                            });
                    }
                })
        },
    }
}
</script>

<style scoped>

</style>
